import Vue from "vue";
import Vuex from "vuex";
import permission from './modules/permission'
import user from './modules/user'
import phone from './modules/phone'
import ivr from './modules/ivr'
import strategy from './modules/strategy'
import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    permission,
    phone,
    ivr,
    strategy
  },
  getters
});
export default store